import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { ElementType, ToolType, WhiteboardElement } from 'ng-whiteboard';
import { WhiteboardHelper } from 'src/app/helpers/whiteboard.helper';
import { DrawingProperties, FontOption, LineStyle, LineStyleOption, LineWidthOption } from 'src/app/models/whiteboard';
import { I18Service } from 'src/app/services/i18.service';

@Component({
  selector: 'app-whiteboard-properties-menu',
//   standalone: true,
//   imports: [CommonModule, FormsModule],
  templateUrl: './whiteboard-properties.component.html',
  styleUrls: ['./whiteboard-properties.component.scss']
})
export class WhiteboardPropertiesMenuComponent {
  _activeTool: ToolType = ToolType.Select;
  
  @Input() 
  set activeTool(tool: ToolType){ this._activeTool = tool; setTimeout(() => {this.hidden.emit( !this.showPropertiesButton);}); }
  get activeTool() { return this._activeTool; }

  _selectedElements: WhiteboardElement[] = [];
  @Input()
  set selectedElements(types: WhiteboardElement[]){
    this._selectedElements = types;
    setTimeout(() => {
      this.hidden.emit( !this.showPropertiesButton);
    });
  }
  get selectedElements() { return this._selectedElements; }

  @Input() properties: DrawingProperties = WhiteboardHelper.drawingPropertiesDefaults;

  get isBold(): boolean {
    return this.properties.fontWeight === 'bold';
  }

  get isItalic(): boolean {
    return this.properties.fontStyle === 'italic';
  }

  @Output() propertiesChange = new EventEmitter<DrawingProperties>();
  @Output() hidden = new EventEmitter<boolean>();

  lineWidthOptions: LineWidthOption[] = WhiteboardHelper.lineWidthOptionsDefault;

  lineStyleOptions: LineStyleOption[] = [
    { value: 'solid', label: I18Service.get('Whiteboard.linestyle.solid') },
    { value: 'dashed', label: I18Service.get('Whiteboard.linestyle.dashed') },
    { value: 'dotted', label: I18Service.get('Whiteboard.linestyle.dotted') }
  ];

  fontOptions: FontOption[] = WhiteboardHelper.fontOptionsDefault

  fontSizeOptions = WhiteboardHelper.fontSizeOptionsDefault;

  get showPropertiesButton(): boolean {
    const selectedTypesCount = this.selectedElements.length;
    return ![ToolType.Select, ToolType.Eraser, ToolType.Hand, ToolType.ZoomIn, ToolType.ZoomOut].includes(this.activeTool) || selectedTypesCount > 0;
  }

  get isDrawingTool(): boolean {
    const selectedDrawTypeCount = this.selectedElements.map(z => z.type).filter(t => t != ElementType.Text).length;
    return [ToolType.Pen, ToolType.Line, ToolType.Arrow, ToolType.Ellipse, ToolType.Rectangle].includes(this.activeTool) || selectedDrawTypeCount > 0;
  }

  get isFontTool(): boolean {
    const selectedTextTypeCount = this.selectedElements.map(z => z.type).filter(t => t == ElementType.Text).length;

    return this.activeTool ===  ToolType.Text || selectedTextTypeCount > 0;
  }


  onPropertyChange(): void {
    this.propertiesChange.emit(this.properties);
  }
  onStyleChange(event: MatButtonToggleChange ): void {
    // console.log('whiteboard Style change event:', event);
    // Metodo deprecato - usare toggleBold() e toggleItalic()
  }

  toggleBold(): void {
    const newFontWeight = this.properties.fontWeight === 'bold' ? 'normal' : 'bold';
    this.propertiesChange.emit({
      ...this.properties,
      fontWeight: newFontWeight
    });
  }

  toggleItalic(): void {
    const newFontStyle = this.properties.fontStyle === 'italic' ? 'normal' : 'italic';
    this.propertiesChange.emit({
      ...this.properties,
      fontStyle: newFontStyle
    });
  }

  getStrokeDashArray(style: LineStyle): string {
    return WhiteboardHelper.getStrokeDashArray(style);
  }

  getLineStyleLabel(style: LineStyle): string {
    const option = this.lineStyleOptions.find(opt => opt.value === style);
    return option ? option.label : style;
  }

  getFontDisplay(font: string): string {
    if (font.length > 12) {
      return font.substring(0, 10) + '..';
    }
    return font;
  }
}